"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalizeMoment = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("./utils");

var _StepsContainer = require("./StepsContainer");

var _Modal = require("../../molecules/Modal");

var _atoms = require("../../atoms");

require("./PersonalizeMoment.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Personalize Moment
var PersonalizeMoment = function PersonalizeMoment(_ref) {
  var _moment$spotlights;

  var fullGameMoment = _ref.fullGameMoment,
      className = _ref.className,
      loading = _ref.loading,
      success = _ref.success,
      showConfirmation = _ref.showConfirmation,
      onClose = _ref.onClose,
      onSave = _ref.onSave,
      moment = _ref.moment,
      open = _ref.open,
      game = _ref.game,
      tagsType = _ref.tagsType,
      goToTraceId = _ref.goToTraceId,
      allowEditTime = _ref.allowEditTime,
      allowEditTags = _ref.allowEditTags,
      allowEditTitle = _ref.allowEditTitle,
      allowEditSpotlight = _ref.allowEditSpotlight,
      allowConfirmation = _ref.allowConfirmation,
      loadingMessage = _ref.loadingMessage,
      successMessage = _ref.successMessage,
      confirmButtonText = _ref.confirmButtonText,
      showAllTagsInConfirmStep = _ref.showAllTagsInConfirmStep;
  // Some vars
  var containerKey = "key-".concat(moment.game_clip_id);
  var addtlClassNames = className ? className : "";
  var openClassName = open ? "open" : "";

  var _useState = (0, _react.useState)(allowEditSpotlight ? moment && moment.spotlights && moment.spotlights.length > 0 ? moment.spotlights[0] : null : null),
      _useState2 = _slicedToArray(_useState, 1),
      existingMomentSpotlight = _useState2[0];

  var existingDynamicOffset = moment.dynamic_offset * 1000;
  var correctedUTCStarttime = Math.max(fullGameMoment.start_time, moment.start_time - existingDynamicOffset); // Map the small moment's spotlight on the fullGameMoment

  var fullGameMomentCopy = _objectSpread({}, fullGameMoment);

  if (moment && ((_moment$spotlights = moment.spotlights) === null || _moment$spotlights === void 0 ? void 0 : _moment$spotlights.length) > 0) {
    fullGameMomentCopy.spotlights = [JSON.parse(JSON.stringify(moment.spotlights[0]))];
  } else {
    fullGameMomentCopy.spotlights = [];
  } // A dict for saving our updates


  var _useState3 = (0, _react.useState)({
    tags: [],
    title: moment && moment.title ? moment.title : null,
    didAdjustTitle: false,
    overlayStyles: {},
    didAdjustStartTimeOrDuration: false,
    didAdjustSpotlight: false,
    spotlightEnabled: existingMomentSpotlight !== null,
    spotlightStartAtFormatted: (0, _utils.formatMinutesAndSeconds)(existingMomentSpotlight ? (existingMomentSpotlight.utc - fullGameMoment.start_time) / 1000 : (correctedUTCStarttime - fullGameMoment.start_time) / 1000),
    spotlightStartAtRelative: existingMomentSpotlight ? (existingMomentSpotlight.utc - fullGameMoment.start_time) / 1000 : (correctedUTCStarttime - fullGameMoment.start_time + 500) / 1000,
    spotlightStartAtUTC: existingMomentSpotlight ? existingMomentSpotlight.utc : correctedUTCStarttime,
    spotlightCenterX: existingMomentSpotlight ? existingMomentSpotlight.center[0] : 500,
    spotlightCenterY: existingMomentSpotlight ? existingMomentSpotlight.center[1] : 500,
    startAt: correctedUTCStarttime,
    startAtRelative: Math.floor((correctedUTCStarttime - fullGameMoment.start_time) / 1000),
    stopAt: correctedUTCStarttime + 1000 * (moment === null || moment === void 0 ? void 0 : moment.dynamic_duration),
    stopAtRelative: Math.floor((correctedUTCStarttime + 1000 * moment.dynamic_duration - fullGameMoment.start_time) / 1000)
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      updates = _useState4[0],
      setUpdates = _useState4[1];

  var handleUpdate = function handleUpdate(newUpdates) {
    var existingUpdates = _objectSpread({}, updates);

    for (var property in newUpdates) {
      existingUpdates[property] = newUpdates[property];
    } // Did we update?


    var didAdjustStartTimeOrDuration = newUpdates["didAdjustStartTimeOrDuration"]; // Are we updating the relative start time?

    var startAtRelative = newUpdates["startAtRelative"];

    if (didAdjustStartTimeOrDuration) {
      // const offset = startAtRelative - updates["startAtRelative"]
      existingUpdates["startAt"] = fullGameMoment.start_time + startAtRelative * 1000;
    } // Are we updating the relative stop time?


    var stopAtRelative = newUpdates["stopAtRelative"];

    if (didAdjustStartTimeOrDuration) {
      existingUpdates["stopAt"] = fullGameMoment.start_time + stopAtRelative * 1000;
    } // Are we updating the spotlight relative start at?


    var spotlightStartAtRelative = newUpdates["spotlightStartAtRelative"];

    if (newUpdates["didAdjustSpotlight"]) {
      existingUpdates["spotlightEnabled"] = newUpdates["spotlightEnabled"];
      existingUpdates["spotlightStartAtRelative"] = spotlightStartAtRelative;
      existingUpdates["spotlightStartAtUTC"] = spotlightStartAtRelative * 1000 + fullGameMoment.start_time;
      existingUpdates["spotlightStartAtFormatted"] = (0, _utils.formatMinutesAndSeconds)(existingUpdates["spotlightStartAtRelative"]);
    } // If the moment start time moves beyond spotlight start time OR the moment
    // stop time moves before the spotlight start time, then set spotlight start
    // time to new moment start time (...with a +- 0.5s offset, of course)


    if (startAtRelative + 0.5 > existingUpdates["spotlightStartAtRelative"] || stopAtRelative - 0.5 < existingUpdates["spotlightStartAtRelative"]) {
      existingUpdates["spotlightStartAtRelative"] = startAtRelative + 0.5;
      existingUpdates["spotlightStartAtUTC"] = fullGameMoment.start_time + existingUpdates["spotlightStartAtRelative"] * 1000;
      existingUpdates["spotlightStartAtFormatted"] = (0, _utils.formatMinutesAndSeconds)(existingUpdates["spotlightStartAtRelative"]);
    } // If anything changed, update the spotlight on the fullGameMoment


    if (didAdjustStartTimeOrDuration) {
      fullGameMomentCopy.spotlights[0] = [{
        center: [existingUpdates.spotlightCenterX, existingUpdates.spotlightCenterY],
        utc: existingUpdates.spotlightStartAtUTC
      }];
    } // Set the updates


    setUpdates(existingUpdates); // console.log("finishing handleUpdate", existingUpdates)

    return existingUpdates;
  };

  var handleOnClose = function handleOnClose(e) {
    if (typeof onClose === "function") {
      onClose(e);
    }
  };

  var handleOnRequestSave = function handleOnRequestSave(newUpdates) {
    var upToDateUpdates = handleUpdate(newUpdates);
    console.log("Calling onSave with updates:", upToDateUpdates);

    if (typeof onSave === "function") {
      // If the tags are type === game, we want to add them back in before saving
      if (tagsType === "game") {
        upToDateUpdates.tags = [].concat(_toConsumableArray(upToDateUpdates.tags), _toConsumableArray(moment.tags));
      }

      onSave(upToDateUpdates);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "personalize-container ".concat(addtlClassNames, " ").concat(openClassName),
    key: containerKey,
    trkContext: "Personalize Moment"
  }, /*#__PURE__*/_react.default.createElement(_Modal.Shade, {
    onClick: handleOnClose
  }), /*#__PURE__*/_react.default.createElement(_StepsContainer.StepsContainer, {
    fullGameMoment: fullGameMomentCopy,
    loading: loading,
    success: success,
    game: game,
    moment: moment,
    updates: updates,
    onUpdate: handleUpdate,
    onCloseClick: handleOnClose,
    onRequestSave: handleOnRequestSave,
    showConfirmation: showConfirmation,
    goToTraceId: goToTraceId,
    tagsType: tagsType,
    allowEditSpotlight: allowEditSpotlight,
    allowConfirmation: allowConfirmation,
    allowEditTitle: allowEditTitle,
    allowEditTags: allowEditTags,
    allowEditTime: allowEditTime,
    loadingMessage: loadingMessage,
    successMessage: successMessage,
    confirmButtonText: confirmButtonText,
    showAllTagsInConfirmStep: showAllTagsInConfirmStep
  }));
};

exports.PersonalizeMoment = PersonalizeMoment;
PersonalizeMoment.defaultProps = {
  open: true,
  loading: false,
  success: false,
  loadingMessage: "Personalizing your moment...",
  confirmButtonText: "Create moment",
  allowEditSpotlight: true,
  allowConfirmation: false,
  allowEditTitle: true,
  allowEditTags: true,
  allowEditTime: true,
  tagsType: "trace",
  game: null,
  showAllTagsInConfirmStep: false
};